import { Modal } from "react-bootstrap";
import { useState, useEffect } from "react";
import "./modals.scss";
import useAxios from "../../../services/useAxios";
import { translateToReactSelect } from "../../../utils/helperFunction";
import BankAccountList from "./BankAccountList";
import Tabs from "../../tab/Tabs";
import BaseInfoData from "./BaseInfoData";
import CustomButton from "../../kits/button/CustomButton";
import { EditIcon, CloseIcon } from "../../kits/Icons";
import ToastCustomize from "../../kits/ToastCustomize";
import { CustomTooltip } from "../../kits/tooltip/CustomTooltip";
import { SeparatorInput } from "../../kits/Inputs/Inputs";

export default function AddEditCustomerModal({
  type, //edit,add
  headerText = "",
  data,
  tagOption,
  userOption,
  bankName,
  setCustomerUpdater,
  setTagUpdater,
  show,
  setShow,
}) {
  // const [show, setShow] = useState(false);
  // const [customerData, setCustomerData] = useState({
  //   firstName: "",
  //   lastName: "",
  //   companyName: "",
  //   companyAddress: "",
  //   corporate: true,
  //   mobile: "",
  //   tell: "",
  //   tags: [],
  //   main_uid: [],
  //   bankAccount: [],
  //   newFirstName: "",
  //   newLastName: "",
  //   newMobile: "",
  // });
  const [bankAccountList, setBankAccountList] = useState([]);
  // const [textErr, setTextErr] = useState({});
  // const dataHandler = (name, value, id) => {
  //   if (name == "corporate" && value == false) {
  //     setCustomerData((prev) => {
  //       return { ...prev, [name]: value, companyName: "" };
  //     });
  //   } else if (name == "bankAccount") {
  //     let temp = [
  //       ...customerData.bankAccount,
  //       { ...value, index: customerData.bankAccount.length + 1 },
  //     ];
  //     setCustomerData((prev) => {
  //       return { ...prev, bankAccount: temp };
  //     });
  //   } else if (name == "removeAccount") {
  //     let temp = customerData.bankAccount.filter((c) => c.index != id);
  //     setCustomerData((prev) => {
  //       return { ...prev, bankAccount: temp };
  //     });
  //   } else {
  //     setCustomerData((prev) => {
  //       return { ...prev, [name]: value };
  //     });
  //   }
  // };

  // const errorHandler = (name, value) => {
  //   setTextErr((prev) => {
  //     return { ...prev, [name]: value };
  //   });
  // };

  const [nav, setNav] = useState([]);
  const [tab, setTab] = useState([]);

  const { loadingAddCustomer, execute: AddCustomerApi } =
    useAxios("api2/add_customer");
  const { loadingEditCustomer, execute: EditCustomerApi } =
    useAxios("api2/edit_customer");
  const AddCustomer = (customerData) => {
    // console.log("customerData*****", customerData);
    let bankArray = [];
    for (let i = 0; i < customerData.bankAccount.length; i++) {
      bankArray.push(
        `${customerData.bankAccount[i].account_number},${customerData.bankAccount[i].bank_id},${customerData.bankAccount[i].sheba_number.value},${customerData.bankAccount[i].card_number.value}`
      );
    }

    let newUser = {
      newFirstName: customerData.newFirstName,
      newLastName: customerData.newLastName,
      newMobile: customerData.newMobile,
    };
    let main_uid = {
      main_uid:
        customerData.main_uid?.value != undefined
          ? customerData.main_uid?.value
          : 0,
    };
    let tempData = {
      firstname: customerData.firstName,
      lastname: customerData.lastName,
      company_name: customerData.companyName,
      address: customerData.companyAddress,
      mobile: customerData.mobile,
      tell: customerData.tell,
      tags: customerData?.tags?.map((c) => c.value).toString(),
      bank_accounts: bankArray.join("@@"),
      corporate: customerData.corporate ? 1 : 0,
      economical_number: customerData?.economical_number ?? "",
      identification_code: customerData?.identification_code ?? "",
      postal_code: customerData?.postalCode ?? "",
    };
    let finalData = {};
    if (customerData.main_uid.value == -1)
      finalData = { ...tempData, ...newUser };
    else finalData = { ...tempData, ...main_uid };
    AddCustomerApi(finalData).then((result) => {
      if (result.status == 1) {
        ToastCustomize({
          mainText: "مشتری با موفقیت اضافه شد.",
          duration: 2000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false,
        });
        setShow(false);
        setCustomerUpdater((prev) => !prev);
      } else if (result.status == -2) {
        ToastCustomize({
          mainText: "مشتری با این شماره تماس در سیستم موجود می باشد.",
          duration: 2000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      } else {
        ToastCustomize({
          mainText: "متاسفانه مشکلی پیش آمده است، دوباره تلاش کنید..",
          duration: 2000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      }
    });
  };
  const EditCustomer = (customerData) => {
    console.log("customerData*****", customerData);
    let bankArray = [];
    for (let i = 0; i < customerData.bankAccount.length; i++) {
      bankArray.push(
        `${customerData.bankAccount[i].account_number},${customerData.bankAccount[i].bank_id},${customerData.bankAccount[i].sheba_number?.value},${customerData.bankAccount[i].card_number?.value}`
      );
    }

    let newUser = {
      newFirstName: customerData.newFirstName,
      newLastName: customerData.newLastName,
      newMobile: customerData.newMobile,
    };
    let main_uid = {
      main_uid:
        customerData.main_uid?.value != undefined
          ? customerData.main_uid?.value
          : 0,
    };
    let tempData = {
      firstname: customerData.firstName,
      lastname: customerData.lastName,
      company_name: customerData.companyName,
      address: customerData.companyAddress,
      mobile: customerData.mobile,
      tell: customerData.tell,
      tags: customerData?.tags?.map((c) => c.value).toString(),
      bank_accounts: bankArray.join("@@"),
      corporate: customerData.corporate ? 1 : 0,

      customer_id: customerData.customer_id,
      economical_number: customerData?.economical_number ?? "",
      identification_code: customerData?.identification_code ?? "",
      postal_code: customerData?.postalCode ?? "",
    };
    let finalData = {};
    if (customerData?.main_uid?.value == -1)
      finalData = { ...tempData, ...newUser };
    else finalData = { ...tempData, ...main_uid };
    EditCustomerApi(finalData).then((result) => {
      if (result.status == 1) {
        setShow(false);
        setCustomerUpdater((prev) => !prev);
        ToastCustomize({
          mainText: "ویرایش با موفقیت انجام شد.",
          duration: 2000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false,
        });
      } else
        ToastCustomize({
          mainText: "متاسفانه مشکلی پیش آمده است، دوباره تلاش کنید..",
          duration: 2000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
    });
  };

  useEffect(() => {
    if (type == "edit") {
      // setCustomerData(data);
      console.log("object", data);
      setBankAccountList(data.bankAccountApi);
    }
  }, [show, data]);
  useEffect(() => {
    if (type == "edit")
      setNav([
        { title: " اطلاعات پایه", target: "#base-info-fields" },
        { title: "اطلاعات بانکی", target: "#finance-info-fields" },
      ]);
    else setNav([{ title: " اطلاعات پایه", target: "#base-info-fields" }]);
    setTab([
      {
        id: "base-info-fields",
        component: (
          <div className="col-12 ">
            {" "}
            <BaseInfoData
              // customerData={customerData}
              // dataHandler={dataHandler}
              type={type}
              // textErr={textErr}
              tagOption={tagOption}
              // errorHandler={errorHandler}
              userOption={userOption}
              data={data}
              AddCustomer={AddCustomer}
              bankName={bankName}
              EditCustomer={EditCustomer}
              setTagUpdater={setTagUpdater}
            />
          </div>
        ),
      },
      {
        id: "finance-info-fields",
        component: (
          <div className="col-12 mt-3">
            <p style={{ fontSize: "14px" }}>لیست کارتهای بانکی</p>
            <BankAccountList
              data={bankAccountList}
              bankName={bankName}
              setCustomerUpdater={setCustomerUpdater}
            />
          </div>
        ),
      },
    ]);
  }, [tagOption, data]);

  return (
    <div>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        fullscreen="lg-down"
        className="p-0"
      >
        <Modal.Header>
          {headerText}
          <div
            className="cursor-pointer"
            onClick={() => {
              setShow(false);
            }}
          >
            <CloseIcon />
          </div>
        </Modal.Header>
        <Modal.Body className="add-edit-customer-modal">
          <Tabs navItem={nav} tabContent={tab} type="horiz" />
        </Modal.Body>
      </Modal>
    </div>
  );
}
